"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatScoreMeans = exports.ScoreSection = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const scoring_model_1 = require("../../utils/scoring-model");
const ScoreHeader = (0, styled_components_1.default)(base_react_components_1.Copy).withConfig({ displayName: "reports-ScoreHeader", componentId: "reports-1y92yo0" }) `
  width: 100%;
`;
exports.ScoreSection = styled_components_1.default.div.withConfig({ displayName: "reports-ScoreSection", componentId: "reports-13qvx8o" }) `
  display: flex;
  flex-flow: column nowrap;
  padding: 8px 0;
  grid-gap: 8px;
`;
const letterDescriptions = {
    0: 'You have a bankruptcy filing. Equifax’s data shows a formal commercial bankruptcy filing for your business. A bankruptcy makes it difficult to leverage your business credit for financing options or tradelines, especially if the bankruptcy is recent. If you believe this bankruptcy is appearing in error, you can dispute the information directly with Equifax.',
    noScore: 'While your business has a credit file at Equifax, you don’t have enough accounts reporting to generate a credit score. Building an Equifax score can help you access new financing options and open doors to new suppliers, vendors and business partners.',
};
const WhatScoreMeans = ({ children, score, bureau, type }) => {
    var _a;
    const scoringModel = (0, scoring_model_1.getScoringModel)(bureau, type);
    const explanation = scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.explanation;
    return (react_1.default.createElement(exports.ScoreSection, null,
        react_1.default.createElement(ScoreHeader, null,
            react_1.default.createElement(base_react_components_1.Text, { "$bold": true }, (_a = explanation === null || explanation === void 0 ? void 0 : explanation.header) !== null && _a !== void 0 ? _a : '')),
        children,
        react_1.default.createElement(base_react_components_1.Copy, null, score && !isNaN(+score) ? explanation === null || explanation === void 0 ? void 0 : explanation.copy : letterDescriptions.noScore)));
};
exports.WhatScoreMeans = WhatScoreMeans;
exports.default = exports.WhatScoreMeans;
//# sourceMappingURL=index.js.map